import React, { Component } from 'react'
import { connect } from 'react-redux'
import { findUser, fetchCustomers, setSearchingForCustomers } from 'actions'
import {
  getCustomersRequestByWorkspaceSlug,
  getCustomersSearchResultByWorkspaceSlug,
  getCustomersDataByWorkspaceSlug,
  getCustomersCursorByWorkspaceSlug,
  getCustomersSearchRequest
 } from 'selectors'
import CustomersProfiles from '../components/Customers/CustomersProfiles'

class CustomersProfilesApp extends Component {
  render () {
    return React.createElement(CustomersProfiles, this.props)
  }

  componentDidMount () {
    this.props.fetchCustomers()
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params

  const users = getCustomersDataByWorkspaceSlug(state, workspaceSlug)
  const searchResult = getCustomersSearchResultByWorkspaceSlug(state, workspaceSlug)
  const searchRequest = getCustomersSearchRequest(state, workspaceSlug)
  const cursor = getCustomersCursorByWorkspaceSlug(state, workspaceSlug)
  const { isRequesting, didRequestFail } = getCustomersRequestByWorkspaceSlug(state, workspaceSlug)
  const { isSearchingForCustomer } = state.application.customers

  return {
    isSearchingForCustomer,
    isRequesting,
    didRequestFail,
    searchRequest,
    rowCount: !isSearchingForCustomer ? users.length + 1 : 1,
    users: !isSearchingForCustomer ? users : searchResult,
    workspaceSlug,
    isNextPageLoading: isRequesting,
    hasNextPage: cursor.has_next,
    next: cursor.next
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const { workspaceSlug } = ownProps.params

  return {
    onFindUser: (data) => dispatch(findUser(workspaceSlug, data)),
    setSearchingForCustomers: (bool) => dispatch(setSearchingForCustomers(bool)),
    fetchCustomers: (next) => dispatch(fetchCustomers(workspaceSlug, next))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersProfilesApp)



// WEBPACK FOOTER //
// ./containers/CustomersProfilesApp.js